import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import RouteLink from 'flow/components/ui-components/RouteLink';
import useAppContext from 'flow/hooks/useAppContext';
import useVoicemail from 'flow/hooks/useVoicemail';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';

interface Props {
    extensionKey: ExtensionKey;
    type: 'busy' | 'unavail';
}

const types = {
    busy: {
        label: 'settings.voicemail_busy',
        url: routes['settings.voicemail.busy'],
    },
    unavail: {
        label: 'settings.voicemail_unanswer',
        url: routes['settings.voicemail.unavailable'],
    },
};

const PlaybackMessage = ({ extensionKey, type }: Props) => {
    const { i18next } = useAppContext();
    const { voicemailSettings } = useVoicemail(extensionKey);

    const userSounds = useAppSelector((state) => state.sounds.get('sounds'));

    const getSound = () => {
        if (!voicemailSettings) {
            return;
        }

        const soundKey = voicemailSettings.getIn([`${type}Sound`, 'key']);
        const standardSound = voicemailSettings.get('standardVoicemailSound');

        if (standardSound.get('key') === soundKey) {
            return standardSound.get('name');
        }

        if (voicemailSettings.has(`${type}SoundFile`)) {
            return voicemailSettings.getIn([`${type}SoundFile`, 'name']);
        }

        if (!userSounds || userSounds?.isEmpty()) {
            return null;
        }

        return userSounds
            .find((userSound) => userSound.get('key') === soundKey)
            ?.get('name', null);
    };

    return (
        <RouteLink to={types[type].url} description={getSound()}>
            {i18next.t(types[type].label)}
        </RouteLink>
    );
};

export default PlaybackMessage;
